// components/AdminRoute.jsx
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

export default function DentalRoute({ children }) {
    const data = JSON.parse(localStorage.getItem('admin'))
    const token = data?.token

  if (!token) return <Navigate to="/dental/login" replace />;

  try {
    const decoded = jwtDecode(token);
    const exp  = decoded?.exp;
    const role = decoded?.role;

    if (role !== 'dental' || exp * 1000 < Date.now()) {
      localStorage.removeItem('adminToken');
      return <Navigate to="/dental/login" replace />;
    }

    return children;
  } catch {

    localStorage.removeItem('admin');
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    return <Navigate to="/dental/login" replace />;
  }
}
